import { useState } from "react";
import TimeAgo from "../../utils/timeAgo";
import Chip from '@mui/material/Chip';
import { getUserAvatarStatus, getUserVideoConStatus } from "../../utils/getUserAvatarStatus";



const TransactionTableMini = ({ transactions, status, handleViewDetails, additionalFields = [], isGenerating=false,handleSearch }) => {



    

    const renderField = (field, transaction) => {

       
        if (field.type === 'chat-button') {
            return (
                <button className={`btn btn-sm btn-label-${field.color}`} onClick={() => field.onClick(transaction)}>
                    {field.title}
                    [{typeof field.label === 'function' ? field.label(transaction) : field.label}]
                </button>
            );
        }
        else if (field.type === 'generate-meeting-button') {
            if(typeof field.condition === 'function'){

                // console.log(field.condition(transaction));
                
                if(field.condition(transaction)==="join"){
                    return (
                        <button
                        className={`btn btn-sm btn-outline-primary w-100`}
                        onClick={() => field.onClickJoin(transaction)}>
                            Join
                        </button>
                    )
                    ;
                }
                else if(field.condition(transaction)==="generate meeting"){
                    return (
                        <button className={`btn btn-sm btn-outline-${field.color} w-100`} onClick={() => field.onClickGenerate(transaction)} disabled={isGenerating}>
                            {isGenerating ?
                                <><span className="spinner-grow me-1" role="status" aria-hidden="true"></span>Generating...</>
                                :
                                <><span  className="" role="status" aria-hidden="true"></span>Create Meeting</>
                            }
                        </button>
                    )
                }
                else if(field.condition(transaction)==="payment required"){
                    return (
                        // <span className="badge rounded-pill bg-danger">PAYMENT REQUIRED</span>
                        <></>
                    )
                }
            }
            
        } 
        else if (field.type === 'button') {
            return (
                <button className={`btn btn-sm btn-label-${field.color}`} onClick={() => field.onClick(transaction)}>
                    {field.title}
                </button>
            );
        } 
        else if (field.type === 'select') {
            return (
                <select onChange={(e) => field.onChange(e, transaction)}>
                    {field.options.map((option, index) => (
                        <option key={index} value={option.value}>{option.label}</option>
                    ))}
                </select>
            );
        } else if (field.type === 'textbox') {
            return <input type="text" value={field.value(transaction)} onChange={(e) => field.onChange(e, transaction)} />;
        } else {
            return field.value(transaction);
        }
        
        
        
    };

    const [search, setSearch] = useState("");
    

    return (
        <>
           <div className="row d-flex align-items-start justify-content-between p-4">
                    <div className="input-group shadow-none">
                        <input type="text" placeholder="Search here..." className="form-control" onChange={(e) => setSearch(e.target.value)}  aria-label="Text input with dropdown button" />
                        <button className="btn btn-outline-primary" onClick={()=>handleSearch(search)} type="button">
                            Search
                        </button>
                    </div>

           
            </div>


            <div className="card h-100">
                <div className="card-header d-flex align-items-center justify-content-between">
                    <h5 className="card-title m-0 me-2">Transactions</h5>

                </div>
                <div className="card-body">
                    <ul className="p-0 m-0">

                        {transactions.length > 0 ? (
                            transactions.map((transaction) => (

                                <li className="d-flex mb-4 pb-1"  key={transaction.transaction_id}>
                                      <div className={`avatar avatar-md flex-shrink-0 me-3 ${getUserAvatarStatus(transaction.user_status_updatedAt)}`}>
                                        <img src={transaction.user_profile_photo} alt="" className="rounded" style={{objectFit:"cover",width:48,height:48}} />
                                    </div>


                                      <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                        <div className="me-2">
                                            <small className="text-muted d-block mb-1">{transaction.document_name?.toUpperCase() === "TITLE YOUR DOCUMENT" ? transaction.document_title : transaction.document_name}</small>
                                            <h6 className="mb-0">₱ {transaction.document_price} -
                                                <span className={`ms-2 fs-6 badge bg-${transaction.transaction_payment_status.toUpperCase() === "PAID" ? 'success' : 'danger'}`} style={{ width: 75 }}>{transaction.transaction_payment_status}</span>
                                            </h6>

                                        </div>


                                        









                                        <div className="user-progress d-flex align-items-center gap-1">

                                            {additionalFields.map((field, index) => (
                                                <td key={index}>{renderField(field, transaction)}</td>
                                            ))}
                                            

                                            <button className="btn btn-sm btn-outline-primary text-nowrap " onClick={() => handleViewDetails(transaction)} >
                                                View Information
                                            </button>

                                        </div>
                                      </div>
                                    </li>
                            ))
                        ) : (
                            <div className="w-100 text-center">
                            <Chip label={`NO ${status} TRANSACTION`} icon={<i className='bx bx-edit' />} color='error' />
                            </div>
                        )}


 


                    </ul>
                </div>
            </div>



            <div className="table-responsive bg-white card rounded-0 rounded-bottom shadow-none d-none" >
            
                <table className="table table-borderless table-striped text-center mb-0 ">
                    <thead>
                        <tr className="bg-label-primary">
                            <th>ID</th>
                            <th>Document</th>
                            <th>Name</th>
                            <th>Created</th>
                            {additionalFields.map((field, index) => (
                                <th key={index}>{typeof field.label === 'function' ? field.title : field.label}</th>
                            ))}
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody className="px-3">
                        {transactions.length > 0 ? (
                            transactions.map((transaction) => (
                                <tr key={transaction.transaction_id}>
                                    <td>{transaction.transaction_id} <br/>
                                        {/* <span className={`badge rounded-pill bg-${transaction.transaction_type.toUpperCase() === "VIRTUAL" ? 'warning' : 'success'}`}>{transaction.transaction_type}</span> */}
                                        <span className="badge bg-primary" >{transaction.transaction_status}</span>

                                    </td>
                                    <td className="text-start">
                                        <div className="d-flex w-100 align-items-start gap-2">
                                            <div className="avatar avatar-md flex-shrink-0 me-3">
                                                <img src={transaction.user_profile_photo} alt="" className="rounded" style={{objectFit:"cover",width:48,height:48}} />
                                            </div>
                                            <div className="d-flex justify-content-between flex-grow-1 flex-wrap">
                                                <div>
                                                    <h6 className="mb-0">{transaction.document_name?.toUpperCase()==="TITLE YOUR DOCUMENT" ? transaction.document_title:transaction.document_name}</h6>
                                                    <small className="text-muted" style={{ width: 75 }}>₱ {transaction.document_price}</small>
                                                    <span className={`ms-2 badge bg-${transaction.transaction_payment_status.toUpperCase()==="PAID"?'success':'danger'}`} style={{ width: 75 }}>{transaction.transaction_payment_status}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="fw-bold">{transaction.full_name}</td>
                                    <td><TimeAgo dateString={transaction.date_created} /></td>
                                    {additionalFields.map((field, index) => (
                                        <td key={index}>{renderField(field, transaction)}</td>
                                    ))}
                                    <td>
                                        <button className="btn btn-sm btn-outline-primary text-nowrap " onClick={() => handleViewDetails(transaction)} >
                                            View Information
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={6 + additionalFields.length}>
                                    <Chip label={`NO ${status} TRANSACTION`} icon={<i className='bx bx-edit' />} color='error' />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default TransactionTableMini;